module.exports = __webpack_public_path__ + "media/images/malvinas/Sist_Malvinas_Color-e443a89732d1ac599a3df127c18838ec.svg";